import React from "react";
import CustomButton from "../../../components/CustomButton.jsx";

const FormStepFooter = ({ step, stepActions }) => {
  if (!stepActions[step]) return null;

  const { primaryText, onPrimary, cancelText, onCancel } = stepActions[step];

  return (
    <div
      style={{
        position: "sticky",
        bottom: "0",
        left: "0",
        width: "100%",
        marginTop: "20px",
        paddingBottom: "5px",
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
      }}
    >
      {cancelText && (
        <CustomButton
          text={cancelText}
          bgColor="transparent"
          color="#000"
          fontSize="14px"
          fontWeight="600"
          boxShadow="none"
          height="36px"
          onClick={onCancel}
        />
      )}
      {primaryText && (
        <CustomButton
          text={primaryText}
          bgColor="#000"
          color="#fff"
          fontSize="14px"
          fontWeight="600"
          height="36px"
          borderRadius="8px"
          padding="0 32px"
          width={primaryText === "Enable Notification" ? "151px" : undefined}
          onClick={onPrimary}
        />
      )}
    </div>
  );
};

export default FormStepFooter;
